<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/foreword">Foreword, by Penny Pitou</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">Skiing Takes the Lakes Region by Storm</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Early Years: From Rope Tows to Ski Jumps</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">The Creation of the Belknap Mountains Recreation Area</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">The Hussey Manufacturing Company’s Gift to the Lakes Region</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Transformation: Farming to Recreation</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Torger Tokle: Norway’s Legendary Ski Sensation and America’s Adopted Son</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Growing Pains: The Postwar Years</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Fritzie Baer: The Man in the Red Hat</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">First Chairlift in the East: Celebration and Tragedy</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">The Gilford Outing Club: A Forty-Six-Year Odyssey</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Gary Allen: Coach, Mentor, Ski Icon</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Penny Pitou: Gilford’s Fearless and Determined Olympian</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">From Belknap to Gunstock: Changes for the Area</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Gunstock Nordic Association and Gunstock Ski Club: One Shall Become Two</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">The Continuing Evolution: Maintaining the Competitive Edge</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Gunstock’s Rich Ski History: Its Preservation Is Its Future</span></p>
<p class="toc1"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7feef820